import React from 'react'

const Status = () => {
  return (
    <div className='status-wrap'>
        <span>Verification Status</span>
        <div className='status'>
            <img src="https://finditzstg.wpengine.com/wp-content/uploads/2024/11/status-close.svg" alt="Status" />
            <span>Not Yet Verified</span>
        </div>
    </div>
  )
}

export default Status